export function contoursFromUnresolvedPieces(pieces) {
  const contours = [];
  for (const piece of pieces || []) {
    for (const ring of piece.contours || []) {
      if (!Array.isArray(ring) || ring.length < 3) continue;
      const points = ring.map((point) =>
        Array.isArray(point)
          ? { x: Number(point[0]), y: Number(point[1]) }
          : { x: Number(point.x), y: Number(point.y) }
      );
      if (points.some((point) => !Number.isFinite(point.x) || !Number.isFinite(point.y)))
        continue;
      const first = points[0];
      const last = points[points.length - 1];
      const closed =
        Math.hypot(first.x - last.x, first.y - last.y) <=
        Math.max(1e-6, Math.hypot(first.x, first.y) * 1e-9);
      let body = closed ? points.slice(0, -1) : points;
      if (body.length < 3) continue;
      if (body.length > 2000) {
        const step = (body.length - 1) / 599;
        body = Array.from({ length: 600 }, (_, index) =>
          body[Math.min(body.length - 1, Math.round(index * step))]
        );
      }
      contours.push(body);
    }
  }
  if (!contours.length)
    throw new Error("Trace could not read the unfinished outline. Draw satin edges for that leftover by hand.");
  if (contours.length > 128)
    throw new Error(
      `This leftover has ${contours.length} outlines. Auto supports up to 128 at a time; finish some of it manually first.`
    );
  return contours;
}

export function nextLayerRailsFromSatinResult(current, result, { merge } = {}) {
  if (!result?.pairs?.length)
    throw new Error("No validated rail pairs were returned.");
  return {
    pairs: merge ? [...(current?.pairs || []), ...result.pairs] : result.pairs,
    autoCuts: merge
      ? [...(current?.autoCuts || []), ...(result.cuts || [])]
      : result.cuts,
    autoSatinBeta: true,
    autoSatinPartial: !result.complete,
    autoIssues: result.issues || [],
    autoUnresolvedPieces: result.unresolvedPieces || [],
  };
}

export function unfinishedSatinLabel(count) {
  return count === 1 ? "unfinished piece" : "unfinished pieces";
}
